import { useAppSelector } from '@/store/hooks';

type TReturnHook = {
    totalPrice: number;
};

export const useCalculatorBasket = (): TReturnHook => {
    const formData = useAppSelector((state) => state.calculatorForm.data);

    const getTotalPrice = (): number => {
        return Object.keys(formData).reduce((acc, key) => {
            return acc + formData[parseInt(key)].calculatePrice;
        }, 0);
    };

    return {
        totalPrice: getTotalPrice(),
    };
};
